import React from 'react';

import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import {
  Button,
} from '@mui/material';

import AddTemperature from '../../../HealthRecord/HealthRecordCategory/Temperature/AddTemperature';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

/** 入力 */
export type LineButtonsInput = {
  /** 日付 */
  date: Date,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const TemperatureButton: React.FC<LineButtonsInput> = ({
  date,
  user,
  child,
  facilityList,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<DeviceThermostatIcon />}
        style={{ marginLeft: 'auto', marginRight: '3px' }}
        onClick={() => setIsOpen(true)}
      >
        体温
      </Button>
      <AddTemperature
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        child={child}
        user={user}
        date={date}
        facilityList={facilityList}
      />
    </>
  );
};

export default TemperatureButton;
